<template>
	<div>
		<div class="kc-maincontainer">
			<div class="kc-reg-container">
				<div
					class="kc-reg-head d-flex align-items-center justify-content-center"
				>
					Register
				</div>
				<div class="kc-register-detail mt-5">
					<div class="topDiv mt-4">
						<label class="keylabel">First Name &nbsp;</label>
						<b-form-input
							class="labelbox"
							id="input-1"
							placeholder="Enter here"
							autofocus
							type="text"
							v-model.trim="$v.firstname.$model"
							:class="{ error: $v.firstname.$error }"
						></b-form-input>
						<div
							class="validationicon"
							v-if="$v.firstname.$dirty && !$v.firstname.required"
							v-b-popover.hover.top.v-danger="{ content: 'Required' }"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
					</div>

					<div class="topDiv mt-4">
						<label class="keylabel">Last Name &nbsp;</label>
						<b-form-input
							class="labelbox"
							id="input-1"
							placeholder="Enter here"
							autofocus
							type="text"
							v-model.trim="$v.lastname.$model"
							:class="{ error: $v.lastname.$error }"
						></b-form-input>
						<div
							class="validationicon"
							v-if="$v.lastname.$dirty && !$v.lastname.required"
							v-b-popover.hover.top.v-danger="{ content: 'Required' }"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
					</div>

					<div class="topDiv mt-4">
						<label class="keylabel">Email &nbsp;</label>
						<b-form-input
							class="labelbox"
							id="input-1"
							placeholder="Enter here"
							autofocus
							type="text"
							v-model.trim="$v.email.$model"
							:class="{ error: $v.email.$error }"
						></b-form-input>
						<div
							class="validationicon"
							v-if="$v.email.$dirty && !$v.email.required"
							v-b-popover.hover.top.v-danger="{ content: 'Required' }"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
						<div
							class="validationicon"
							v-if="!$v.email.maxLength"
							v-b-popover.hover.top.v-danger="{
								content: 'Should not exceed 64 characters',
							}"
							variant="primary"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
						<div
							class="validationicon"
							v-if="!$v.email.alpha"
							v-b-popover.hover.top.v-danger="{
								content: 'Email is invalid',
							}"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
					</div>

					<div class="topDiv mt-4">
						<label class="keylabel">User Name &nbsp;</label>
						<b-form-input
							class="labelbox"
							id="input-1"
							placeholder="Enter here"
							autofocus
							type="text"
							v-model.trim="$v.username.$model"
							:class="{ error: $v.username.$error }"
						></b-form-input>
						<div
							class="validationicon"
							v-if="$v.username.$dirty && !$v.username.required"
							v-b-popover.hover.top.v-danger="{ content: 'Required' }"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
					</div>

					<div class="topDiv mt-4">
						<label class="keylabel">Password &nbsp;</label>
						<b-form-input
							class="labelbox"
							id="input-1"
							placeholder="Enter here"
							autofocus
							type="password"
							v-model.trim="$v.password.$model"
							:class="{ error: $v.password.$error }"
						></b-form-input>
						<div
							class="validationicon"
							v-if="$v.password.$dirty && !$v.password.required"
							v-b-popover.hover.top.v-danger="{ content: 'Required' }"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
					</div>

					<div class="topDiv mt-4">
						<label class="keylabel">Confirm Password &nbsp;</label>
						<b-form-input
							class="labelbox"
							id="input-1"
							placeholder="Enter here"
							autofocus
							type="password"
							v-model.trim="$v.confirmpassword.$model"
							:class="{ error: $v.confirmpassword.$error }"
						></b-form-input>
						<div
							class="validationicon"
							v-if="$v.confirmpassword.$dirty && !$v.confirmpassword.required"
							v-b-popover.hover.top.v-danger="{ content: 'Required' }"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
					</div>

					<div class="text-center">
						<b-button @click="validateuser" class="addbtn pr-3 pl-3 mt-5"
							>Submit</b-button
						>
					</div>
					<div
						class="d-flex align-items-center justify-content-center text-center mt-3"
					>
						<img src="../../assets/kcbackbutton.svg" alt="" />
						<router-link to="/login">
							<div class="kc-reg-backtoprev ml-2">
								Back To Login
							</div>
						</router-link>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { required, email, helpers, maxLength } from "vuelidate/lib/validators";
export default {
	name: "keycloakregister",
	data() {
		return {
			username: "",
			password: "",
			showPassword: false,
		};
	},
	validations: {
		firstname: {
			required,
		},
		lastname: {
			required,
		},
		username: {
			required,
		},
		password: {
			required,
		},
		confirmpassword: {
			required,
		},
		email: {
			required,
			email,
			alpha: helpers.regex(
				"alpha",
				/^[a-z0-9]+[._-]*[a-z0-9]+@[a-z0-9]+\.[a-z]{2,3}$/i
			),
			maxLength: maxLength(64),
		},
	},
	methods: {
		validateuser() {
			this.$v.$touch();
		},
	},
};
</script>

<style>
.kc-maincontainer {
	height: 100vh;
	background: url("../../assets/keycloakbg.png") no-repeat center center fixed;
	-webkit-background-size: cover;
	-moz-background-size: cover;
	-o-background-size: cover;
	background-size: cover;
	position: relative;
	display: flex;
	place-content: center;
	place-items: center;
}
.kc-reg-container {
	position: absolute;
	background: #ffffff;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
	padding: 35px 50px;
	width: 45%;
}
.kc-reg-head {
	font-weight: 600;
	font-size: 25px;
	color: #72738e;
}

.keylabel {
	background-color: var(--bg-inputfield);
	position: absolute;
	left: 0.5vw;
	top: -9px;
	font-weight: 500;
	font-size: 12px;
	/* identical to box height */
	color: #72738e;
	line-height: 18px;
	z-index: 5;
	padding-left: 6px;
	padding-right: 4px;
}

.newuser {
	margin-top: 30px;
	text-align: center;
	color: #72738e;
	font-weight: 500;
	font-size: 14px;
	line-height: 21px;
}
.reg {
	margin-top: 30px;
	text-align: center;
	font-weight: 500;
	font-size: 14px;
	line-height: 21px;
	color: #3f698e;
}
.keyimage {
	position: absolute;
	top: 5px;
	right: 10px;
}
.keyimage img {
	width: 16px;
}
.form-control:focus {
	border: 0.7px solid rgba(114, 115, 142, 0.7) !important;
	box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.25) !important;
}

.labelbox {
	border-radius: 3px !important;
	background: #fdfdfd;
	border: 0.7px solid rgba(114, 115, 142, 0.7);
	box-sizing: border-box;
	box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.25);
	padding-left: 6px;
}
.kc-reg-backtoprev {
	font-weight: 600;
	font-size: 14px;
	line-height: 18px;
	/* identical to box height, or 129% */

	text-decoration-line: underline;

	color: #3f698e;
}
</style>
